import styled from '@emotion/styled';
import { Menu } from 'antd';
import { DateInput } from 'semantic-ui-calendar-react';
import { Checkbox as SemanticCheckbox, Form, Message as SemanticMessage } from 'semantic-ui-react';

import { hexToRgba } from 'src/shared/helpers/hexToRgba';
import { color, font, shadow } from 'src/shared/styles/variables';

export const Message = styled(SemanticMessage)({
    '&&.error': {
        padding: '0 0 0 10px',
        border: 'none',
        boxShadow: 'none',
        backgroundColor: 'transparent',
        ...font.roman(font.size.small),
        '&, & a': {
            lineHeight: 1.5,
            letterSpacing: 0.2,
            color: color.monza,
        },
        '& a': font.heavy(font.size.small),
    },
});

export const Input = styled(Form.Input)({
    '&&.field': {
        '& label': {
            margin: 0,
            lineHeight: 2,
            color: `${color.fiord} !important`,
            ...font.heavy(font.size.base),
        },
        '& input': {
            transition: 'background-color 0.2s ease-in-out',
            border: ` 1px solid ${color.linkWaterLight} !important`,
            boxShadow: `${shadow.regularShadow} !important`,
        },
        '&.error input': {
            borderradius: 4,
            border: `solid 1px ${color.monza}`,
        },
        '&:not(.error)': {
            '& .icon': {
                display: 'none',
            },
            '& input:not(:focus):valid': {
                backgroundColor: hexToRgba(color.raffia, 0.26),
                maxHeight: 38,
                paddingTop: 14,
                letterSpacing: 0.2,
                color: color.black,
                ...font.medium(font.size.medium),
            },
        },
    },
});

export const FormField = styled(Form.Field)({
    '&&.field': {
        height: 58,
        '& label': {
            margin: 0,
            lineHeight: 2,
            color: `${color.fiord} !important`,
            ...font.heavy(font.size.base),
        },
    },
    '&&.error div': {
        borderRadius: 4,
        border: `solid 1px ${color.monza}`,
        backgroundColor: hexToRgba('#fff6f6', 1),
    },
});

interface DatePickerProps {
    fulfilled: number;
}

export const DatePicker = styled<any>(DateInput)<DatePickerProps>(props => ({
    '&&.field input': props.fulfilled
        ? {
              backgroundColor: hexToRgba(color.raffia, 0.26),
              paddingTop: 14,
              paddingBottom: 8,
              letterSpacing: 0.2,
              color: color.black,
              ...font.medium(font.size.medium),
              border: ` 1px solid ${color.linkWaterLight} !important`,
              boxShadow: `${shadow.regularShadow} !important`,
          }
        : {
              border: ` 1px solid ${color.linkWaterLight} !important`,
              boxShadow: `${shadow.regularShadow} !important`,
              paddingBottom: 12,
              paddingTop: 12,
          },
}));

export const InvalidCredentials = styled('p')(
    {
        lineHeight: 1.5,
        letterSpacing: 0.2,
        color: color.monza,
    },
    font.medium(font.size.base),
);

export const TermsBox = styled('div')({
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: 12,
});

export const TermsInfo = styled('p')({
    marginLeft: 10,
});

export const Anchor = styled('a')({
    cursor: 'pointer',
    textDecoration: 'underline',
});

export const Strong = styled('strong')({
    ...font.heavy(font.size.base),
});

export const Checkbox = styled(SemanticCheckbox)({
    width: 15,
    height: 15,
});

export const DropdownWrapper = styled('div')({
    letterSpacing: 0.2,
    color: color.black,
    textTransform: 'capitalize',
    ...font.medium(font.size.medium),
    border: ` 1px solid ${color.linkWaterLight} !important`,
    boxShadow: `${shadow.regularShadow} !important`,
    borderRadius: 5,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: color.white,
    '&:hover': {
        backgroundColor: color.athensGray,
    },
    padding: '0.5rem',
    width: '120px',
    float: 'left',
    marginRight: '10px',
    marginBottom: 14,
    '&:last-child': {
        marginRight: '0px',
    },
});

export const MenuWrapper = styled(Menu)({
    height: '200px',
    overflow: 'scroll',
});

export const MenuItem = styled(Menu.Item)({
    paddingTop: 0,
    paddingBottom: 0,
    '&&:hover': {
        backgroundColor: color.athensGray,
    },
    textAlign: 'center',
});

interface MenuItemTextProps {
    withBorder?: boolean;
}

export const MenuItemText = styled.p<MenuItemTextProps>(() => ({
    paddingBottom: 5,
    paddingTop: 10,
    borderBottom: `1px solid transparent`,
    color: color.pickledBluewood,
    ...font.heavy(font.size.base),
}));
